import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const TopRightNextArrow = ({ onClick, isDisabled, color = "white" })=>/*#__PURE__*/ _jsx("button", {
        type: "button",
        className: "carousel-arrow-wrapper next",
        onClick: onClick,
        tabIndex: 0,
        disabled: isDisabled,
        style: {
            background: "transparent",
            border: "none",
            boxShadow: "none",
            padding: 0
        },
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "62",
            height: "62",
            viewBox: "0 0 62 62",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("circle", {
                    cx: "31",
                    cy: "31",
                    r: "30.5",
                    transform: "matrix(-1 0 0 1 62 0)",
                    fill: "transparent",
                    stroke: color
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M43.7071 30.2929C44.0976 30.6834 44.0976 31.3166 43.7071 31.7071L37.3431 38.0711C36.9526 38.4616 36.3195 38.4616 35.9289 38.0711C35.5384 37.6805 35.5384 37.0474 35.9289 36.6569L41.5858 31L35.9289 25.3431C35.5384 24.9526 35.5384 24.3195 35.9289 23.9289C36.3195 23.5384 36.9526 23.5384 37.3431 23.9289L43.7071 30.2929ZM19 30L43 30V32H19V30Z",
                    fill: color
                })
            ]
        })
    });
export default TopRightNextArrow;
